<pp-search-box
  [ppPlaceholder]="'search_fleet' | ppTranslate"
  (ppAction)="setKeyword($event)"
  ppSize="wide"
></pp-search-box>
